<template>
  <div><span>Loading....</span></div>
</template>

<script>
export default {
  name: 'LoadingPlaceholder'
}
</script>
